import { useEffect, useState } from "react";
import { useAuth } from "../App";
import ProfilePhotoCropper from "./ProfilePhotoCropper";

/**
 * Blocking app-level gate: when the logged-in user has no profile picture
 * (or backend flagged profile_photo_required), force the cropper open. Cannot
 * be dismissed until they upload a valid face photo. Mounted once in App.js.
 */
export default function ProfilePhotoGate() {
  const { user, isAuthenticated, checkAuth } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !user) {
      setOpen(false);
      return;
    }
    const needs = !user.picture || user.profile_photo_required === true;
    setOpen(Boolean(needs));
  }, [isAuthenticated, user]);

  if (!isAuthenticated || !user) return null;
  if (!open) return null;

  return (
    <ProfilePhotoCropper
      open={open}
      onOpenChange={setOpen}
      blocking
      onUploaded={async () => {
        await checkAuth();
        setOpen(false);
      }}
    />
  );
}
